import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environment';
import { LegalArticleTypes } from '@models/article/legal-article-types.enum';
import { SearchableArticle } from '@models/article/searchable-article';
import { Article } from '@models/content-api/article';
import { Observable } from 'rxjs';

export interface Version {
  articleId: string;
  version: string;
  date: string;
  objectId: string;
  selected?: boolean;
}

@Injectable({ providedIn: 'root' })
export class ContentWebservice {
  constructor(private readonly http: HttpClient) {}

  getAllVersionsByType(type: LegalArticleTypes): Observable<Version[]> {
    return this.http.get<Version[]>(`${environment.api.content}/v1/versions/1jeune1solution/${type}`);
  }

  getLastVersionByType(type: LegalArticleTypes): Observable<SearchableArticle> {
    return this.http.get<SearchableArticle>(`${environment.api.content}/v1/article/1jeune1solution/${type}`);
  }

  getArticleByTypeAndVersion(version: string, type: LegalArticleTypes): Observable<SearchableArticle> {
    return this.http.get<SearchableArticle>(`${environment.api.content}/v1/article/1jeune1solution/${type}/${version}`);
  }

  getArticleBySlug(slug: string): Observable<Article> {
    return this.http.get<Article>(`${environment.api.content}/v1/facade/1j1s-mesures-${slug}`);
  }
}
